<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">
    Welcome to the Dicker Data News Section. This page is updated frequently with important product information regarding our
    vendors and their products. Please check back regularly to ensure you have the latest tools and information to assist
    you. If you have any questions about a particular article you've seen in the News Section please contact sales@dickerdata.com.au
  </div>
  <div #entry>


  </div>
</div>
